import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';

import { logging, logPostInfo } from '../../actions/log';
import { getRankList } from '../../actions/wallpaper';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import { getQueryString } from '../../utils/utils';
import Blank from './Blank';
import styles from './WallPaperRank.module.less';
import useResize from '../../utils/hooks/useResize';
import useLoginStatus from '../../utils/hooks/useLoginStatus';
import WpProductDownload from '../../components/WallpaperCard/WpProductDownloadBtn';

const selectWpRankList = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.rankList,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function WPRank() {
  // export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { action } = history;
  const [pageContent, setPageContent] = useState(null);
  const rankList = useSelector(selectWpRankList);
  const logInfoData = useSelector(selectLogInfo);

  const code = getQueryString('code');
  const pay = getQueryString('pay') || '0'; // 是否为快照接口
  const wallpaperId = getQueryString('wallpaperId');

  const [initTime, setInitTime] = useState(+new Date());
  const { showNumber, getClassType } = useResize();
  const loginStatus = useLoginStatus();

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Wallpaper_RankMore||${code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_RankMore',
        label: '',
        param2: {
          source: `Wallpaper_RankMore||${code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_RankMore||${code}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  // 处理回退没有数据白屏的问题
  useActivate(() => {
    if (code !== rankList.code) {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          skip: 0,
          code,
          pay,
          wallpaperId,
          refresh: true,
        }),
      );
    }
  }, [rankList]);

  /**
   * 获取榜单图片
   */
  useEffect(() => {
    dispatch(
      getRankList({
        ...rankList.pagenation,
        skip: 0,
        code,
        pay,
        wallpaperId,
        refresh: true,
      }),
    );
  }, [loginStatus]);

  const loadMore = useCallback(() => {
    if (
      rankList.load !== true &&
      rankList.code === code &&
      rankList.list.length < rankList.pagenation.count
    ) {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          code,
          wallpaperId,
        }),
      );
    }
  });

  if (rankList.list.length === 0 && rankList.load) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }
  if (rankList.list.length === 0 && rankList.load === false) {
    return <Blank load={rankList.load} />;
  }
  return (
    <div className={styles.page} ref={r => setPageContent(r)}>
      <div className={styles.page_container}>
        {rankList.name && <div className={styles.rank_name}>{rankList.name}</div>}
        {rankList.pay === 1 && (
          <div className={styles.rank_download}>
            <WpProductDownload wallpaper={{ ...rankList, type: 2 }} hasDownloading={true}>
              一键下载
            </WpProductDownload>
          </div>
        )}
        {rankList.desc && <div className={styles.rank_desc}>{rankList.desc}</div>}
        {code === rankList.code && (
          <InfiniteScroll
            pageStart={1}
            loadMore={loadMore}
            hasMore={rankList.list.length < rankList.pagenation.count}
            loader={
              <div className="loader" key={0}>
                ----------加载中----------
              </div>
            }
            initialLoad={false}
            useWindow={false}
            getScrollParent={() => pageContent}
          >
            <div className={styles.showreel}>
              {rankList.list.map((item, index) => {
                return (
                  <WallpaperCard
                    wallpaper={item}
                    key={index}
                    cardInfo={{
                      pageSource: 'rank',
                      code,
                      classType: getClassType(index, showNumber),
                      isCollect: true,
                      isWallpaper: true,
                      isDeleteColl: false,
                      isDeleteUsed: false,
                      isPreview: true,
                    }}
                    logInfo={{ source: `Wallpaper_RankMore||${code}` }}
                  />
                );
              })}
              {rankList.list.length >= rankList.pagenation.count && rankList.pagenation.count > 5 && (
                <div className="loader" style={{ width: '100%' }}>
                  ----------到底啦----------
                </div>
              )}
            </div>
          </InfiniteScroll>
        )}
        <ScrollTop node={pageContent} />
      </div>
    </div>
  );
}
// });

export default porps => {
  const history = useHistory();
  const { refresh } = useAliveController();
  const code = getQueryString('code');

  useEffect(() => {
    if (history.action === 'PUSH') {
      refresh(`wprank_${code}`);
    }
  }, []);
  return (
    <KeepAlive name={`wprank_${code}`} saveScrollPosition="screen" id={code}>
      <WPRank />
    </KeepAlive>
  );
};

// export default () => {
//   return (
//     <KeepAlive name={`wprank_${code}`} id={code}>
//       <WPRank></WPRank>
//     </KeepAlive>
//   );
// };
